import { addMilliseconds } from 'date-fns'
import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { putCookie } from '@chilecompra/react-kit/storages'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Gets a public access token.
 */
export const getAuthToken = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/auth/publico`, {
    callback: response =>
      putCookie('access_token', response.data.payload?.access_token, {
        expires: addMilliseconds(new Date(), response.data.payload?.expires_in * 1000)
      }),
    isPublic: true
  })
)
